<template>
  <teleport to="body" v-if="visible">
    <div class="popup">
      <div class="popup__bg" @mousedown="emitClose"></div>
      <div
        class="popup__body"
        tabindex="0"
        ref="popupRef"
      >
        <span class="popup__close" @click="emitClose"></span>
        <slot name="content"></slot>
      </div>
    </div> 
  </teleport>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, ref, watch } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emits = defineEmits(['close']);
const emitClose = () => emits('close');


const popupRef = ref<HTMLElement | null>(null);

const handleKey = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    emitClose();
  }
};

watch(() => props.visible, (newVal) => {
  document.body.style.overflow = newVal ? 'hidden' : 'initial';

  if (newVal) {
    document.addEventListener('keydown', handleKey);
  } else {
    document.removeEventListener('keydown', handleKey);
  }
});

onBeforeUnmount(() => {
  document.body.style.overflow = 'initial';
  document.removeEventListener('keydown', handleKey);
});

</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100%;
  padding: 32px 0;
  overflow: auto;

  &__body {
    position: relative;
    margin: auto;
    border-radius: 12px;
    width: 100%;
    padding: 20px;
    max-width: 480px;
    background: #090A0C;
  }

  &__bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.2);
    backdrop-filter: blur(4px);
  }

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    display: block;
    width: 25px;
    height: 25px;
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KCjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+Cjxzdmcgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJNZW51IC8gQ2xvc2VfU00iPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTYgMTZMMTIgMTJNMTIgMTJMOCA4TTEyIDEyTDE2IDhNMTIgMTJMOCAxNiIgc3Ryb2tlPSIjNzM3ODgwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=) no-repeat center/cover;
    cursor: pointer;
  }
}
</style>